$(document).on('turbolinks:load', function () {
    if (!document.location.pathname.match(/^\/internal_stocks/)) {
        return;
    }

    let form = $('#search_form');
    let originalFormValues = {};
    let isRestoringFormValues = false;
    let isClearButtonClicked = false;
    let disableEvent = false;
    if (form.length === 0) {
        console.error('Form with id "search_form" not found!');
        return;
    }

    if (document.location.pathname.match(/^\/internal_stocks/)) {

        if (document.location.pathname.match(/^\/internal_stocks$/)) {
            let $table = $('#steel_pipe_list_table');
            $table.floatThead({
                scrollContainer: function ($table) {
                    return $table.closest('.table-responsive');
                }
            });
        }

        function defineSearchForm() {
            // 検索
            $('.search-form').off('ajax:success');
            $('.search-form').on('ajax:success', function (event) {
                const [json, status, xhr] = event.detail;
                const contentType = xhr.getResponseHeader("content-type") || "";
                console.log('Content Type:', contentType);
                if (contentType.indexOf('html') > -1) {
                    alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
                    location.href = '/login';
                }
                if (contentType.indexOf('json') > -1) {
                    if (json.error) {
                        alert(json.error);
                        return false;
                    }
                    $(this).find('.search-result').html(json.result);
                    if ($('.item').length >= !json.research) {
                    }

                    console.log('Prepending new item.');
                    $('#items').prepend(json.item);

                    defineSizefullSelect();
                }
            });

            $('.search-form').off('ajax:error');
            $('.search-form').on('ajax:error', function (event) {
                const [json, status, xhr] = event.detail;
                alert(status);
            });

            //検索条件クリア
            $('.clear').on('click', function () {
                isClearButtonClicked = true;
                let form = $(this).closest('form');
                form.find('select').val(null).trigger('change');
                form.find('.item-name-hidden').val('');
                form.find('.form-control-static.item-name').text('');
                $('.steel-pipe-name-select').val(null).trigger('change');
                $('#steel-pipe-name-select').hide();
                isClearButtonClicked = false;
            });

            //検索フォームの状態を最新の値で再反映する
            function applyCurrentFormValues() {
                isClearButtonClicked = true;
                updateFormToLatestValues();
                isClearButtonClicked = false;
            }

            // 現在のフォームの状態を保存する関数
            function saveCurrentFormValues() {
                let form = $('.clear').closest('form');

                if (form.length === 0) {
                    form = $('#searchForm');
                }

                originalFormValues = {};

                form.find('select, .item-name-hidden, .form-control-static.item-name, input[type="hidden"]').each(function () {
                    let element = $(this);
                    let key = element.attr('id') || element.attr('name') || element.attr('class');

                    if (key) {
                        if (element.is('select') || element.is('input[type="hidden"]')) {
                            originalFormValues[key] = element.val();
                        } else {
                            originalFormValues[key] = element.text();
                        }
                    }
                });

                return originalFormValues;
            }

            //フォームの要素を最新の状態に更新する関数
            function updateFormToLatestValues() {
                let form = $('.clear').closest('form');

                if (form.length === 0) {
                    form = $('#searchForm');
                }

                form.find('select, .item-name-hidden, .form-control-static.item-name, input[type="hidden"]').each(function () {
                    let element = $(this);

                    if (element.is('select')) {
                        element.trigger('change.select2');
                    } else {
                        element.trigger('change');
                    }
                });
            }

        //検索条件変更時に検索結果をクリアする
        function addSearchConditionChangeListener() {
            let form = $('.clear').closest('form');
            if (form.length === 0) {
                form = $('#searchForm');
            }

            const searchInputs = 'select, .item-name-hidden, .form-control-static.item-name, input[type="hidden"]';

            form.off('change.searchCondition', searchInputs);
            $('.open-modal').off('click.searchCondition');

            // 検索条件の入力要素に変更があった場合の処理
            form.on('change.searchCondition', searchInputs, function(e) {
                if (disableEvent || isRestoringFormValues || isClearButtonClicked) {
                    return;
                }

                if ($('#steel_pipe_list_table_body').children().length > 0) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    $('#steel_pipe_list_table_body').empty();
                    // 変更されたのが寸法セレクトボックスの場合、鋼種名をクリアして再検索
                    if ($(this).hasClass('size-full-select')) {
                        $('.steel-pipe-name-select').html('').val(null).trigger('change');
                        $(this).trigger('change.with-request');
                    }
                    saveCurrentFormValues();
                }
            });

            // カテゴリボタン（モーダルを開くボタン）のクリック処理
            $('.open-modal').on('click.searchCondition', function(e) {
                if ($('#steel_pipe_list_table_body').children().length > 0) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    $('#steel_pipe_list_table_body').empty();
                    applyCurrentFormValues();
                    $($(this).closest('a').data('target')).modal('show');
                }
            });
        }

            // 選択した鋼管の一覧表示ボタンのクリックイベント
            $('.add-steel-pipe-list').off('click').on('click', function (e) {
                e.preventDefault();
                saveCurrentFormValues();
                addSteelPipeList();
            });

            //鋼管一覧の各行にある「検索」ボタン押下時、Ajax通信が成功したらその行を新しい情報で更新する
            $(document).on('ajax:success', '.steel_pipe_list_table_item', function(event) {
                var $form = $(this);
                var $tr = $form.closest('tr');
                var response = event.detail[2].responseText;
                $tr.replaceWith(response);
            });

            initializeSelect2();
            set_tooltip();
            addSearchConditionChangeListener();
            saveCurrentFormValues();
        }

        defineSearchForm();

        // Ajaxリクエストの成功時にselect2を再初期化
        document.addEventListener('ajax:success', (event) => {
            if (event.target.closest('#tanka-tokuisaki-code-form li a')) {
                $('#tanka-tokuisaki-code-form').html(event.detail[0]['paginator']);
                $('#tanka-tokuisaki-code-form > tbody').html(event.detail[0]['company_ids']);
                defineItemNameCodeSelect();
            }
        });

        //単価得意先コードセレクトボックスを初期化
        function initializeSelect2() {
            $('.tanka-tokuisaki-select:not(.select2-hidden-accessible)').select2({
                width: 'resolve'
            });
        }

        // ツールチップを有効化する
        function set_tooltip() {
            $('[data-toggle="tooltip"]').tooltip();
        }

        // スマホ用クリックイベントの設定
        $('#info-icon').on('click', function () {
            var tooltip = $(this).attr('data-original-title');
            alert(tooltip);
        });

        // ==================商品選択で使用する関数ここから================================

        // カテゴリ/寸法から検索の鋼管選択モーダルから鋼管を選んだ際に情報を取得してくる
        $('.steel-pipe-form').on('ajax:success', function (event) {
            const [json, status, xhr] = event.detail;
            const contentType = xhr.getResponseHeader("content-type") || "";
            if (contentType.indexOf('html') > -1) {
                alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
                location.href = '/login';
            }
            if (contentType.indexOf('json') > -1) {
                $('#selected-steel-pipe-cuttable').val(json.steel_pipe_is_cuttable)
                setSteelPipeItem(json)
            }
            $(this).parents('.modal').modal('hide')
        });
        $('.steel-pipe-form').on('ajax:error', function (event) {
            const [json, status, xhr] = event.detail;
            alert(status);
        });

        // /stocks/steel_pipe からのレスポンスを各フォームにセット
        function setSteelPipeItem(json) {
            $('.item-name').html(json.item_name);
            $('.item-name-hidden').val(json.item_name);
            $('.size-full-select').html(json.size_fulls);
            $('.steel-pipe-name-select').html('');

            if ($('.size-full-select').parent().find('.selection').length === 0) {
                $('select.select2.size-full-select')
                    .select2({placeholder: '選択してください'})
            }
            $('select.select2.size-full-select').val(null).trigger('change.select2');
            $('select.select2.steel-pipe-name-select').val(null).trigger('change.select2');

            $('#selected-steel-pipe-type').val(json.steel_pipe_type)
            defineSizefullSelect();

            if (json.is_size_full_search) {
                // 鋼種名セレクトボックスの横幅を合わせる
                let other_select_width = $(json.target_id + ' ' + 'select.select2.size-full-select').parent().find('.selection').width()

                $('#steel-pipe-name-select').show()
                $('select.select2.steel-pipe-name-select').parent().find('.select2-container').width(other_select_width)
            }else{
                $('#steel-pipe-name-select').hide()
            }
            $('select.select2.steel-pipe-name-select')
                .val(null).select2({placeholder: '寸法を選択してください'})
        }

        // 寸法のセレクトボックスを変更した際に鋼種名を取得する
        function defineSizefullSelect() {
            $('.size-full-select').off('change.with-request');
            $('.size-full-select').on('change.with-request', function(event){

            $.ajax({
                url: '/internal_stocks/steel_pipe_name',
                type: 'post',
                data: {
                    size_full_text: $(this).val(),
                    steel_pipe_type: $('#selected-steel-pipe-type').val(),
                },
                success: function(json, status, xhr) {
                    var contentType = xhr.getResponseHeader("content-type") || "";
                    if (contentType.indexOf('html') > -1) {
                        alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
                        location.href = '/login';
                    }
                    if (contentType.indexOf('json') > -1) {
                        $('.steel-pipe-name-select')
                            .html(json.steel_pipe_names);
                        if (json.single_flg) {
                            $('select.select2.steel-pipe-name-select')
                                .select2({placeholder: '選択してください'})
                            $('select.select2.steel-pipe-name-select')
                                .val(json.steel_pipe_name).trigger('change.select2');
                        }else {
                            $('select.select2.steel-pipe-name-select')
                                .select2({placeholder: '選択してください'})
                            $('select.select2.steel-pipe-name-select')
                                .val(null).trigger('change.select2');
                        }
                    }
                },
                error: function(xhr, status, e) {
                    alert(status);
                }
            });
        });
    }

        //「寸法」セレクトボックスの値に応じて、「鋼種名」セレクトボックスを有効化または無効化
        function updateSteelPipeNameSelectState() {
            var sizeFullValue = $('.size-full-select').val();
            var steelPipeNameSelect = $('.steel-pipe-name-select');

            if (sizeFullValue) {
                steelPipeNameSelect.prop("disabled", false);
            } else {
                steelPipeNameSelect.prop("disabled", true);
            }
        }

        // .size-full-selectの変更イベントでボタンの状態を更新
        $(document).on('change', '.size-full-select', function () {
            $(this).select2('close');
            updateSteelPipeNameSelectState();
        });

        // 鋼種名セレクトボックスの変更イベントも追加
        $(document).on('change', '.steel-pipe-name-select', function () {
            updateSteelPipeNameSelectState(); // 状態更新を呼び出す
        });

// ==================商品選択で使用する関数終わり================================

        //選択した鋼管の一覧表示
        function addSteelPipeList() {
            errors = addSteelPipeListErrorMessage()

            if (errors.length > 0) {
                alert(errors.join("\n"))
                return false
            }

            $.ajax({
                url: '/internal_stocks/add_steel_pipe_list',
                type: 'post',
                data: {
                    stock_search: {
                        item_name: $('.item-name-hidden').val(),
                        size_full: $('.size-full-select').val(),
                        steel_pipe_name: $('.steel-pipe-name-select').val(),
                        zaiko_busho_code: $('#zaiko_busho').val(),
                        tanka_busho_code: $('#tanka_busho').val(),
                        tanka_tokuisaki_code: $('#tanka_tokuisaki_code').val() || '18999001',
                    },
                    steel_pipe_type: $('#selected-steel-pipe-type').val(),
                },
                success: function (json, status, xhr) {
                    const contentType = xhr.getResponseHeader("content-type") || "";
                    if (contentType.indexOf('html') > -1) {
                        alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
                        location.href = '/login';
                    }
                    if (contentType.indexOf('json') > -1) {
                        if (json.error) {
                            alert(json.error);
                            return false;
                        }
                        // 既存の検索結果をクリアしてから新しい結果を表示（上書き）
                        $('#steel_pipe_list_table_body').empty();
                        $('#steel_pipe_list_table_body').append(json.item);

                        var addedElement = $('#steel_pipe_list_table_body').children().last();
                    }
                },
                error: function (xhr, status, e) {
                    alert(status);
                }
            });
        }

        // 商品選択のフォームに必須情報が入力されているかのチェック
        function addSteelPipeListErrorMessage() {
            errors = []
            $('.item-name-hidden').val() ? '' : errors.push('品名・規格名を入力してください')
            if ($('#steel-pipe-name-select').is(':visible') && !$('.steel-pipe-name-select').val()) {
                errors.push('鋼種名を選択してください')
            }
            if (!$('#zaiko_busho').val() && !$('#tanka_busho').val()) {
                errors.push('在庫部所または単価部所のいずれかを入力してください');
            }
            return errors
        }

        // 在庫検索api失敗時の処理
        $(document).off('ajax:success', '.steel-pipe-search-form');
        $(document).on('ajax:success', '.steel-pipe-search-form', function (event) {
            const [json, status, xhr] = event.detail;
            const contentType = xhr.getResponseHeader("content-type") || "";
            if (contentType.indexOf('json') > -1 && json.error) {
                alert(json.error);
            return false;
            }
        });
    }
});
